import $ from 'jquery';
import 'jquery';
import './bootstrap';
import smoothscroll from 'smoothscroll-polyfill';


import './map-settings';
import './infoModal';
import umeReadyAccordions from './accordion';
import umeMoreFrontend from './ume-more-frontend';
import umeMenuInit from './menu';
import umeSlidersInit from  './events-slider';
import scrollDownOnClick from './scrollDown';
import swiper from './slider';
import './donation-form';


$(document).ready(() => {
    umeMenuInit();
    scrollDownOnClick();
    umeMoreFrontend();
    umeSlidersInit();
    umeReadyAccordions();

    smoothscroll.polyfill();

});